import { lazy } from "react";
import ErrorBoundary from "@/hoc/ErrorBoundary/ErrorBoundary.jsx";

const ContactUs = lazy(() => import("./ContactUs"));

export const contactUsRoute = {
  path: "contactUs",
  element: <ContactUs />,
  errorElement: <ErrorBoundary />
};
